import { AxiosPromise, AxiosStatic } from "axios";

export interface NoticePeriodAllocation {
  targetDealId: string;
  amount: number;
  noticePeriodMonths?: number;
  label?: string;
  rateAtTimeOfChoice?: number;
  loyaltyBoostAtTimeOfChoice?: number | null;
  memberRateAtTimeOfChoice?: number | null;
}

export interface EntitySubmission {
  sourceCommitmentId: string;
  allocations: NoticePeriodAllocation[];
  incomeDecision?: "WITHDRAW" | "REALLOCATE" | null;
  incomeReallocationDealId?: string;
  incomeReallocationLabel?: string;
  distributionAmount?: number | null;
  bankAccountId?: string;
}

export interface NoticePeriodChoiceSubmission {
  entities: EntitySubmission[];
  isMember?: boolean;
}

export interface FundRestructureAllocationData {
  destinationDealId: string;
  noticePeriodMonths: number;
  label: string;
  amount: number;
  rateAtTimeOfChoice: number;
  loyaltyBoostAtTimeOfChoice: number | null;
  memberRateAtTimeOfChoice: number | null;
}

export interface FundRestructureSubmissionData {
  allocations: FundRestructureAllocationData[];
  incomeDecision: "WITHDRAW" | "REALLOCATE" | null;
  incomeReallocationDealId?: string;
  incomeReallocationLabel?: string;
  distributionAmount: number | null;
  isMember: boolean;
}

export interface FundRestructureChoice {
  id: string;
  sourceCommitmentId: number;
  investorId: number;
  sourceDealId: number;
  submission: FundRestructureSubmissionData;
  reallocationIds: string[] | null;
  isProcessed: boolean;
  created_at: string;
  updated_at: string;
}

export const submitNoticePeriodChoice =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: NoticePeriodChoiceSubmission): AxiosPromise<{ reallocationIds: string[] }> =>
    await appAxios.post(
      `${serverURL}/reallocations/notice-period-choice`,
      data,
      {
        withCredentials: true,
      }
    );

export const getNoticePeriodChoices =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (dealId: string): AxiosPromise<FundRestructureChoice[]> =>
    await appAxios.get(`${serverURL}/reallocations/notice-period-choices`, {
      params: { dealId },
      withCredentials: true,
    });
